import PropTypes from 'prop-types';
import {useEffect, useState} from 'react';
import RadioButton from 'infrastructure/js/components/controls/RadioButton/radioButton';
import {getCoCResultOptions} from '../../utils/cocHelper';

import './cocGraphViewer.scss'

export default function CoCGraphViewer({
                                         graph,
                                         index,
                                         name,
                                         isViewOnly = false,
                                         onGraphResultChange = null,
                                       }) {

  const [graphUrl, setGraphUrl] = useState(null);

  useEffect(() => {
    if (!graph) {
      setGraphUrl(null);
      return;
    }

    let newUrl;

    if (graph.file) {
      newUrl = URL.createObjectURL(graph.file);
      setGraphUrl(newUrl);
    } else {
      setGraphUrl(graph.url || null);
    }

    return () => {
      if (newUrl) URL.revokeObjectURL(newUrl);
    };
  }, [graph]);

  const onResultChange = (value) => {
    onGraphResultChange?.(value, graph);
  }

  return (
    <div className='coc-graph-viewer'>

      <div className="pdf-content-viewer">
        <RadioButton key={`graphResult-${index}`}
                     id={`${name}.[graphResult]`}
                     name={`${name}.fid-${graph?.id}`}
                     className="short-textfield"
                     labelsAndValues={getCoCResultOptions()}
                     disabled={isViewOnly}
                     onChange={onResultChange}
        />

        { graphUrl ? (
          <object data={graphUrl} type="application/pdf">
            <p>PDF failed to load.</p>
          </object>
        ) : (
          <p>No PDF found</p>
        )}
      </div>
    </div>
  )
}

CoCGraphViewer.propTypes = {
  graph: PropTypes.object,
  index: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  onGraphResultChange: PropTypes.func,
}
